export default __webpack_public_path__ + "static/Calm-3856e0f3037716fc79781dd14c9b8cde.png";